
export const RESTRICTED_INDICATORS = [
  "bulk density (pes)",
];

export const EXCLUDED_INDICATORS = [
  "dry matter",
  "field soil content",
  "whc soil content",
];

export const ORDER = [
  "microbial biomass",
  "respiration",
  "metabolic quotient",
  "whc water content",
  "field water content",
  "om loi",
  "om dumas",
  "total carbon",
  "soil organic carbon",
  "cn ratio",
  "total nitrogen",
  "nitrate nitrogen",
  "ammonium nitrogen",
  "mg",
  "k",
  "p",
  "ph",
  "sand 2.00-0.063mm",
  "silt 0.063-0.002mm",
  "clay <0.002mm",
  "bulk density",
  "bulk density (pes)",
];

export const GradientColors = [
  "#A2EE6E",
  "#7FDF81",
  "#5FBF92",
  "#479E9D",
  "#387DA3",
  "#2A5B8C",
  "#1E3C72",
  "#0A2463",
];
